import React from 'react';
import ReactPlayer from 'react-player';

import { VideoModalContext } from '../../utils/contexts';
import { Container, Modal, Content } from '../../styles/modals/generic-modal';
import Header from './parts/modal-header';

export default function VideoEmbedModal(props) {

	return (
		<VideoModalContext.Consumer>
			{
				({ url, isOpen, setIsOpen }) => {

					if (isOpen) {
						window.history.pushState(null, null, window.location.pathname);
						window.addEventListener('popstate', (e) => {
							e.preventDefault();
							setIsOpen(false)
						});
					}

					return <Container visible={isOpen} className="bg" onClick={(e) => e.target.classList.contains('bg') && setIsOpen(false)}>
						<Modal >
							<Header onCloseClick={() => setIsOpen(false)} />
							<Content fullWidth >
								<ReactPlayer url={isOpen ? url : ''} width="100%" height="100%" controls={true} style={{
									width: 'auto',
									height: 0,
									overflow: 'hidden',
									position: 'relative',
									paddingBottom: '56.25%'
								}} />
							</Content>
						</Modal>
					</Container>
				}
			}
		</VideoModalContext.Consumer>
	);

}